var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('listado-descuentos-clientes-tabla',{attrs:{"data":_vm.data,"getListaDescuentosClientes":_vm.getListaDescuentosClientes,"dataInicial":_vm.dataInicial}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }